@if (mode === 'loading') {
<div class="dialog-content centered">
  <mat-spinner diameter="48"></mat-spinner>
  <p class="status-text">Loading organisation data…</p>
</div>
}

@if (mode === 'select') {
<div class="dialog-content">
  <h3 class="dialog-title">Export Organisation</h3>
  <p class="dialog-subtitle">
    <strong>{{ data.orgName }}</strong> — select which data to include in the export.
  </p>

  <div class="select-all-row">
    <mat-checkbox
      [checked]="allChecked"
      [indeterminate]="someChecked"
      (change)="toggleAll($event.checked)">
      Select all
    </mat-checkbox>
  </div>

  <div class="entity-list">
    @for (entity of entities; track entity.key) {
    <div class="entity-row">
      <mat-checkbox [(ngModel)]="entity.checked">
        {{ entity.label }}
      </mat-checkbox>
      <span class="entity-count">{{ entity.count | number }}</span>
    </div>
    }
  </div>

  <div class="action-row">
    <button mat-raised-button (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!hasSelection" (click)="confirmExport()">
      <mat-icon>download</mat-icon> Export
    </button>
  </div>
</div>
}

@if (mode === 'error') {
<div class="dialog-content centered">
  <mat-icon class="error-icon">error</mat-icon>
  <h3 class="dialog-title">Export Failed</h3>
  <p class="status-text error-msg">{{ errorMessage }}</p>
  <div class="action-row justify-center">
    <button mat-raised-button (click)="close()">Close</button>
  </div>
</div>
}
